<template>
  <div class="check px-1 py-1">
    <input type="checkbox" v-model="active" class="btn-check" :id="domId" autocomplete="off">
    <label class="btn btn-outline-secondary rounded-pill fw-bold w-100" :for="domId">{{ name }}</label>
  </div>

  <input v-if="active" id="requirements" name="requirements" type="hidden" :value="this.id" required >
</template>

<script>
export default {
  name: "Requirement",
  emits:['toggle'],
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    hours: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      active: false,
    }
  },

  watch: {
    active: function () {
      this.$emit('toggle', { id: this.id, hours: this.hours,name: this.name }, this.active);
    }
  },

  computed: {
    domId() {
      return `requirement-component-${this.id}`
    }
  },
}
</script>

<style lang="scss">
@import '@/scss/variables';

.btn-check:checked + label {
  border: 1px solid $primary;
  color: $primary;
  background-color: $primary-200;
}
</style>
